import { SearchSortOrder } from '#server/models';

const currentYear = new Date().getFullYear(); // todo make this dynamic

export const courseSortOrders: SearchSortOrder[] = [
  {
    title: 'Relevance',
    type: 'relevance',
  },
  {
    title: 'Sort by A - Z',
    type: 'field',
    field: 'sortableTitle',
    order: 'asc',
  },
  {
    title: 'Sort by Z - A',
    type: 'field',
    field: 'sortableTitle',
    order: 'desc',
  },
  {
    title: 'ATAR High to Low',
    type: 'nested',
    order: 'desc',
    field: 'calculations.Atar.Value',
    nestedPath: 'calculations.Atar',
    nestedFilter: {
      field: 'calculations.Atar.Year',
      value: currentYear.toString(),
      varyByYear: true,
    },
  },
  {
    title: 'ATAR Low to High',
    type: 'nested',
    order: 'asc',
    field: 'calculations.Atar.Value',
    nestedPath: 'calculations.Atar',
    nestedFilter: {
      field: 'calculations.Atar.Year',
      value: currentYear.toString(),
      varyByYear: true,
    },
  },
  {
    title: 'Duration (Short to Long)',
    type: 'field',
    field: 'calculations.Duration.fullDurationMinutes',
    order: 'asc',
  },
  {
    title: 'Duration (Long to Short)',
    type: 'field',
    field: 'calculations.Duration.fullDurationMinutes',
    order: 'desc',
  },
];
